import { useAuthStore } from '~/stores/auth'
import { createUseApi } from '~/composables/base/createUseApi.ts'

export function useApi() {
  const authStore = useAuthStore()

  return createUseApi({
    getAuthHeader: () => authStore.authorizationHeader,
    setAccessToken: (token: string) => authStore.setAccessToken(token),
    logout: () => authStore.onLogoutHandler()
  })
}
